/**
 * Lottery statuses
 */
export enum LotteryStatusType {
  ACTIVATED = 'activated',
  DRAFT = 'draft',
  COMPLETED = 'completed',
  EDIT = 'edit',
  INTERNAL = 'internal',
  EXECUTION = 'execution',
}
